import { createContext } from "react";

export interface InboxPanelState {
  isOpen: boolean;
  isTransitioning: boolean;
  panelWidth: number;
  headerHeight: number;
  /**
   * The side-panel tab to fall back to when the URL does not carry one.
   * Lives above the router, so it survives navigations that drop the query
   * string (session memory). Only mirrored to localStorage -- so it also
   * survives a reload -- when a caller opts in via `{ persist: true }`; a
   * deliberate tab-bar click persists, but incidental tab changes (e.g. a
   * card selection jumping to RO Details) do not overwrite the user's last
   * deliberately-chosen tab.
   */
  rememberedTab: string | null;
  /**
   * The RO to fall back to when the URL does not carry one. In-memory only:
   * this provider has no shopId, and an RO id is meaningful in one shop only.
   */
  rememberedCardId: string | null;
  /**
   * Whether the Search Results tab should be present in the tab bar.
   * Session-only (never persisted) — Enter-triggered, not a deliberate
   * tab-bar click. Set true by the dashboard search box's Enter handler;
   * set false once the search is cleared.
   */
  hasSearchResults: boolean;
  setHasSearchResults: (value: boolean) => void;
  togglePanel: () => void;
  openPanel: () => void;
  closePanel: () => void;
  setHeaderHeight: (height: number) => void;
  rememberTab: (tab: string, options?: { persist?: boolean }) => void;
  rememberCardId: (cardId: string | null) => void;
}

export const InboxPanelContext = createContext<InboxPanelState | undefined>(
  undefined
);
